export default __webpack_public_path__ + "static/media/020_start_moreInfo.ebac82b4.mp3";